import React, { useState, useEffect, memo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import queryString from 'query-string';
import parseObjectToQuery from '@/utils/functions/parseObjectToQuery';

import SearchInput from '@/views/components/SearchInput/SearchInput';

import styles from '@/views/pages/Departments/Departments.module.scss';

const DepartmentsSearchFilters = ({ resetSort }) => {
	const location = useLocation();
	const navigate = useNavigate();

	const { search: locationSearch, pathname: locationPathName } = location;

	const { dict } = useSelector((state) => state.app);

	const [ searchedQuery, setSearchedQuery ] = useState('');
	const [ query, setQuery ] = useState('');

	const searchQuery = (searchString = null) => {
		const qu = queryString.parse(locationSearch);
		const copiedSearchParams = Object.assign({}, qu);
		if (searchString === null || searchString.length === 0) {
			if (Object.keys(copiedSearchParams).indexOf('q') !== -1) {
				delete copiedSearchParams.q;
				navigate(`${locationPathName}?${parseObjectToQuery(copiedSearchParams)}`);
			}
		} else {
			resetSort();
			delete copiedSearchParams.ord;
			navigate(`${locationPathName}?q=${encodeURIComponent(searchString)}&page=1`);
		}
	};

	useEffect(() => {
		const searchParams = queryString.parse(locationSearch);
		const copiedSearchParams = Object.assign({}, searchParams);
		if (copiedSearchParams.q) {
			setQuery(copiedSearchParams.q);
			setSearchedQuery("");
		} else {
			setQuery("");
			setSearchedQuery("");
		}
	}, [ location ]);

	return (
		<section className={ styles['departments__searchbar'] }>
			<div className={ styles['departments__searchbar--item'] }>
				<SearchInput
					label={ dict.departments.list.searchLabel }
					placeholder={ "" }
					searchedValue={ searchedQuery }
					value={ query }
					setValue={ setQuery }
					searchFunction={ searchQuery }
				/>
			</div>
		</section>
	);
};

export default memo(DepartmentsSearchFilters);